import React from 'react'
import { useSelector } from 'react-redux'
import { Col, Container, Row, Spinner } from 'react-bootstrap';

function Awards() {
    const allPagesContent = useSelector((state) => state.pages.pages)
    const awardsContent = allPagesContent.find((page) => page.slug === 'awards')
	const isPageLoading = useSelector((state) => state.pages.isLoading)
    return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
        <div className='main-text-section'>
			<Container>
				<Row>
					<Col>
						<h2>Awards</h2>
						<div dangerouslySetInnerHTML={{ __html: awardsContent?.content?.rendered }}></div>
					</Col>
				</Row>
			</Container>
		</div>
    )
}

export default Awards